<template>
  <div class="whole store-add">
    <m-header></m-header>
    <m-sidebar></m-sidebar>
    <div class="data-content">
      <el-form ref="form" label-width="80px" class="content">
        <el-form-item label="门店名称">
          <el-input v-model="product.name" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="联系方式">
          <el-input v-model="product.userPhone" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="门店分类">
          <el-cascader
            style="width: 300px"
            v-model="categorySelect"
            :options="categoryOptions"
            @change="onCategoryChange"
          >
          </el-cascader>
        </el-form-item>
        <!--        <el-form-item label="门店分类">-->
        <!--          <el-select v-model="product.categoryId" placeholder="请选择门店分类">-->
        <!--            <el-option v-for="item in categoryList" :key="item.id" :label="item.name" :value="item.id"/>-->
        <!--          </el-select>-->
        <!--        </el-form-item>-->
        <el-form-item label="买单折扣">
          <el-select
            v-model="product.discount"
            placeholder="请选择活买单折扣"
            style="width: 300px"
          >
            <el-option
              v-for="item in discountList"
              :key="item"
              :label="item"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="门店级别">
          <el-select
            v-model="product.level"
            placeholder="请选择门店级别"
            style="width: 300px"
          >
            <el-option
              v-for="item in levelList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="联系人">
          <el-input v-model="product.linkman" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="联系电话">
          <el-input v-model="product.phone" style="width: 300px"></el-input>
        </el-form-item>
        <el-form-item label="共建比例">
          <el-input
            v-model="product.qtRate"
            style="width: 300px"
            placeholder="请输入共建池比例(0~1)"
          ></el-input>
        </el-form-item>
        <el-form-item label="个人比例">
          <el-input
            v-model="product.userQtRate"
            style="width: 300px"
            placeholder="请输入个人QT比例(0~1)"
          ></el-input>
        </el-form-item>

        <el-form-item label="配送地址">
          <el-select
            v-model="product.regionProvinceCode"
            placeholder="请选择省"
            @change="onChoiceProvince"
          >
            <el-option
              v-for="item in regionProvinceList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="product.regionCityCode"
            placeholder="请选择市"
            @change="onChoiceCity"
          >
            <el-option
              v-for="item in regionCityList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="product.regionCountyCode"
            multiple
            placeholder="请选择区"
            @change="onChoiceCounty"
          >
            <el-option
              v-for="item in regionCountyList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
          <el-select
            v-model="product.regionStreetCode"
            multiple
            placeholder="请选择街道"
            @change="onChoiceStreet"
          >
            <el-option
              v-for="item in regionStreetList"
              :key="item.code"
              :label="item.name"
              :value="item.code"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="同城自提">
          <el-switch v-model="product.isPickBl"></el-switch>
        </el-form-item>
        <el-form-item label="同城配送">
          <el-switch v-model="product.isPs"></el-switch>
          <el-input
            v-model="product.postage"
            style="width: 300px"
            v-if="product.isPs"
          ></el-input>
        </el-form-item>
        <el-form-item label="地图">
          <el-amap-search-box
            :search-option="searchOption"
            :on-search-result="onSearchResult"
          ></el-amap-search-box>
          <el-amap
            class="amap-box"
            :vid="'amap-vue'"
            :events="events"
            :center="center"
            :plugin="plugin"
          >
            <el-amap-marker :position="center" />
          </el-amap>
        </el-form-item>
        <el-form-item label="地址">
          <!-- <el-select v-model="product.provinceCode" placeholder="请选择省" @change="onChoiceProvince">
            <el-option v-for="item in provinceList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <el-select v-model="product.cityCode" placeholder="请选择市" @change="onChoiceCity">
            <el-option v-for="item in cityList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <el-select v-model="product.countyCode" placeholder="请选择区" @change="onChoiceCounty">
            <el-option v-for="item in countyList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <el-select v-model="product.streetCode" placeholder="请选择区">
            <el-option v-for="item in streetList" :key="item.code" :label="item.name" :value="item.code"></el-option>
          </el-select>
          <el-col :span="20" style="margin-top: 10px">

          </el-col> -->
          <el-input
            type="textarea"
            v-model="product.detailed"
            placehoder="请输入详细地址"
            @input="handleDetailed"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="onSubmit" class="btn-submit"
          >提交</el-button
        >
      </el-form>
    </div>
  </div>
</template>

<script>
import { Loading } from "element-ui";
import MSidebar from "components/header/sidebar";
import MHeader from "components/header/header";
import {
  getStoreDiscountList,
  getAllProvince,
  getStoreAllCategory,
  addStore,
  updateStore
} from "api/request";
import { ERR_OK } from "api/config";
import { loadingInstance, Error } from "common/js/util";
import { Success } from "../../common/js/util";
var Geocoder = null;
var center = [106.744611, 26.664717];
export default {
  name: "pageAdd",
  components: {
    MSidebar,
    MHeader
  },
  data() {
    return {
      product: {
        id: null,
        name: null,
        discount: null,
        provinceCode: null,
        cityCode: null,
        countyCode: null,
        street: "",
        streetCode: null,
        regionProvinceCode: null, //配送地址的省code
        regionCityCode: null, //配送地址的市code
        regionCountyCode: null, //配送地址的区code
        regionStreetCode: null, //配送地址的街道code
        regionProvince: null, //配送地址的省名称
        regionCity: null, //配送地址的市名称
        regionCounty: null, //配送地址的区名称
        regionStreet: null, //配送地址的街道名称
        detailed: null,
        phone: null,
        linkman: null,
        isPickBl: null,
        postage: null,
        userPhone: null,
        categoryId: null,
        province: null,
        city: null,
        county: null,
        lng: 0,
        lat: 0,
        level: null
      },
      isPs: "0",
      discountList: [],
      levelList: [
        {
          id: 0,
          name: "分公司"
        },
        {
          id: 1,
          name: "运营中心"
        },
        {
          id: 2,
          name: "服务中心"
        },
        {
          id: 3,
          name: "品牌社区店"
        },
        {
          id: 4,
          name: "联盟站"
        }
      ],
      provinceList: [],
      cityList: [],
      countyList: [],
      streetList: [],
      regionProvinceList: [],
      regionCityList: [],
      regionCountyList: [],
      regionStreetList: [],
      // categoryList: [],
      categoryOptions: [],
      categorySelect: [],
      center: [106.744611, 26.664717],
      searchOption: {
        city: "贵阳",
        citylimit: false
      },
      events: {
        init: o => {
          o.getCity(result => {
            console.log("事件初始化");
            console.log(result);
          });
        },
        click: e => {
          console.log(e);
          var center = [];
          center.push(e.lnglat.lng);
          center.push(e.lnglat.lat);
          this.center = center;
          var that = this;
          Geocoder.getAddress(center, function(status, result) {
            if (status === "complete" && result.info === "OK") {
              var adcode = result.regeocode.addressComponent.adcode;
              var provinceCode = adcode.slice(0, 2) + "0000";
              var cityCode = adcode.slice(0, 4) + "00";
              var countyCode = adcode;
              that.product.provinceCode = provinceCode;
              that.product.province =
                result.regeocode.addressComponent.province;
              that.product.cityCode = cityCode;
              that.product.city = result.regeocode.addressComponent.city;
              that.product.countyCode = countyCode;
              that.product.county = result.regeocode.addressComponent.district;
              that.product.detailed = result.regeocode.formattedAddress;
              that.product.lng = e.lnglat.lng;
              that.product.lat = e.lnglat.lat;
              console.log(result);
            }
          });
        }
      },
      plugin: [
        {
          pName: "Geocoder", // 使用AMap.Geocoder插件
          events: {
            init(o) {
              Geocoder = o; // o 则是AMap.Geocoder的实例 对外部的Geocoder变量进行赋值，在任何地方就都可以使用了
              // self.center 具体坐标 （数组格式） ，function 回调函数
              o.getAddress(center, function(status, result) {
                if (status === "complete" && result.info === "OK") {
                  console.log("初始化插件");
                  console.log(result);
                  // result.regeocode.formattedAddress就是具体位置
                  /* self.input = result.regeocode.formattedAddress
                    document.querySelector('.search-box-wrapper input').value = self.input */
                }
              });
            }
          }
        },
        {
          showMarker: true, // 定位成功后在定位到的位置显示点标记，默认：true
          pName: "Geolocation", // AMap-Geolocation 定位插件
          events: {
            init(o) {
              o.getCurrentPosition((status, result) => {
                if (result && result.position) {
                  var center = [];
                  center.push(result.position.lng);
                  center.push(result.position.lat);
                  this.center = center;
                  /* self.center = [lng, lat]
                    self.loaded = true
                    self.zoom = 18
                    self.$nextTick() */
                }
              });
            }
          }
        }
      ]
    };
  },
  created() {
 //这边接收上个组件传递过来的arry数组，赋值给data中定义的articleTask
   this.product = this.$route.query;
  },
  mounted() {
    let getUserInfo = JSON.parse(window.localStorage.getItem("getUserInfo"));
    if (!getUserInfo) {
      this.$router.push({
        path: "/"
      });
    } else {
      this._getDiscountList();
      this._getProvinceList("0");
      this._getCategoryList();
    }
  },
  methods: {
    handleDetailed(value){
      this.product.detailed = value;
      this.$forceUpdate();
    },
    onSearchResult(e) {
      console.log("搜索返回");
      console.log(e);
      var center = [];
      center.push(e[0].lng);
      center.push(e[0].lat);
      this.center = center;
      var that = this;
      Geocoder.getAddress(center, function(status, result) {
        if (status === "complete" && result.info === "OK") {
          var adcode = result.regeocode.addressComponent.adcode;
          var provinceCode = adcode.slice(0, 2) + "0000";
          var cityCode = adcode.slice(0, 4) + "00";
          var countyCode = adcode;
          that.product.provinceCode = provinceCode;
          that.product.province = result.regeocode.addressComponent.province;
          that.product.cityCode = cityCode;
          that.product.city = result.regeocode.addressComponent.city;
          that.product.countyCode = countyCode;
          that.product.county = result.regeocode.addressComponent.district;
          that.product.detailed = result.regeocode.formattedAddress;
          that.product.streetCode = result.regeocode.addressComponent.towncode;
          that.product.street = result.regeocode.addressComponent.township;
          that.product.detailed = result.regeocode.formattedAddress;
          that.product.lng = e[0].lng;
          that.product.lat = e[0].lat;
          console.log(result);
        }
      });
    },
    mapClick(e) {
      console.log(e);
    },
    onCategoryChange(v) {
      this.categorySelect = v;
      this.product.categoryId = v[1];
    },
    // onChoiceProvince(code) {
    //   this.product.cityCode = this.product.countyCode = this.product.streetCode = null;
    //   this._getCityList(code);
    // },
    // 请选择省
    onChoiceProvince(code) {
      this.product.regionCityCode = this.product.regionCountyCode = this.product.regionStreetCode = null;
      this.regionProvinceList.map(item => {
        if (item.code == code) {
          this.product.regionProvince = item.name;
        }
      });

      this._getCityList(code);
    },
    // onChoiceCity(code) {
    //   this.product.countyCode = this.product.streetCode = null;
    //   this._getCountyList(code);
    // },
    // 请选择市
    onChoiceCity(code) {
      this.product.regionCountyCode = this.product.regionStreetCode = null;

      this.regionCityList.map(item => {
        if (item.code == code) {
          this.product.regionCity = item.name;
        }
      });
      this._getCountyList(code);
    },
    // onChoiceCounty(code) {
    //   this.product.streetCode = null;
    //   this._getStreetList(code);
    // },
    //选择区多选
    onChoiceCounty(codeList) {
      this.product.regionStreet = null;
      this.product.regionCounty = codeList
        .map(code => {
          // 找到匹配的项目
          const item = this.regionCountyList.find(item => item.code === code);
          // 如果找到了项目，则返回其名称；否则返回空字符串
          return item ? item.name : "";
        })
        .join(",");
      this._getStreetList(codeList);
    },
    // 请选择街道
    onChoiceStreet(codeList) {
      this.product.regionStreet = "";
      this.$forceUpdate();
      this.regionStreetList.map(item => {
        for (var i = 0; i < codeList.length; i++) {
          if (item.code == codeList[i]) {
            this.product.regionStreet =
              this.product.regionStreet + "," + item.name;
          }
        }
      });
      // console.log(codeList.toString());
      // console.log(this.product.street);
    },
    //提交
    // onSubmit() {
    //   let isPick = !this.product.isPick ? "0" : "1";
    //   this.product.isPick = isPick;
    //   addStore(this.product).then(res => {
    //     loadingInstance(Loading).close();
    //     if (res.status === ERR_OK) {
    //       Success(this, res);
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    // onSubmit() {
    //   // 将省份代码转换为名称
    //   const provinceItem = this.provinceList.find(
    //     item => item.code === this.product.regionProvince
    //   );
    //   const provinceName = provinceItem ? provinceItem.name : "";

    //   // 将城市代码转换为名称
    //   const cityItem = this.cityList.find(
    //     item => item.code === this.product.regionCity
    //   );
    //   const cityName = cityItem ? cityItem.name : "";

    //   // 将区县代码转换为名称
    //   const countyNames = this.product.regionCounty
    //     .map(code => {
    //       const item = this.countyList.find(item => item.code === code);
    //       return item ? item.name : "";
    //     })
    //     .join(",");

    //   // 将街道代码转换为名称
    //   // const streetNames = this.product.regionStreet
    //   //   .map(code => {
    //   //     const item = this.regionStreetList.find(item => item.code === code);
    //   //     return item ? item.name : "";
    //   //   })
    //   //   .join(",");

    //   // 创建提交数据对象，使用名称替换代码
    //   const submitData = {
    //     ...this.product,
    //     regionProvince: provinceName,
    //     regionCity: cityName,
    //     regionCounty: countyNames
    //     // regionStreet: streetNames
    //   };

    //   // 额外的逻辑处理
    //   let isPick = !this.product.isPick ? "0" : "1";
    //   submitData.isPick = isPick;

    //   // 发送提交数据
    //   addStore(submitData).then(res => {
    //     loadingInstance(Loading).close();
    //     if (res.status === ERR_OK) {
    //       Success(this, res);
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    onSubmit() {
      // 先处理 isPick 字段
      // let isPick = !this.product.isPick ? "0" : "1";
      // this.product.isPick = isPick;

      // 使用解构赋值从 this.product 中排除不需要的字段
      let {
        regionProvinceCode,
        regionCityCode,
        regionCountyCode,
        regionStreetCode,
        ...submissionData
      } = this.product;
      if(submissionData.id !== null && submissionData.id != undefined){
        updateStore(submissionData).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          Success(this, res);
        } else {
          Error(this, res);
        }
      });
      return;
      }
      // 使用剩余的 submissionData 进行提交
      addStore(submissionData).then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          Success(this, res);
        } else {
          Error(this, res);
        }
      });
    },
    //折扣列表
    _getDiscountList() {
      loadingInstance(Loading);
      getStoreDiscountList().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          if (res.data.length > 0) this.discountList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //获取省份列表
    _getProvinceList(code) {
      // loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        // loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.regionProvinceList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //获取市列表
    _getCityList(code) {
      // loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        // loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.regionCityList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    //获取区列表
    _getCountyList(code) {
      // loadingInstance(Loading);
      getAllProvince({
        pcode: code
      }).then(res => {
        // loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          this.regionCountyList = res.data;
        } else {
          Error(this, res);
        }
      });
    },
    // //获取街道 （一个区的街道）
    // _getStreetList(code) {
    //   console.log("传入的区县代码:", code);
    //   // loadingInstance(Loading);
    //   getAllProvince({
    //     pcode: code
    //   }).then(res => {
    //     console.log("返回的街道数据:", res);
    //     // loadingInstance(Loading).close();
    //     if (res.status === ERR_OK) {
    //       this.streetList = res.data;
    //     } else {
    //       Error(this, res);
    //     }
    //   });
    // },
    _getStreetList(codeList) {
      // 将数组转换为逗号分隔的字符串
      const pcodeParam = codeList.join(",");
      console.log("传入的区县代码:", codeList);
      getAllProvince({
        pcode: pcodeParam
      })
        .then(res => {
          console.log("返回的街道数据:", res);
          if (res.status === ERR_OK) {
            this.regionStreetList = res.data;
          } else {
            Error(this, res);
          }
        })
        .catch(error => {
          console.error("获取街道数据出错:", error);
        });
    },
    //获取门店分类
    _getCategoryList() {
      loadingInstance(Loading);
      getStoreAllCategory().then(res => {
        loadingInstance(Loading).close();
        if (res.status === ERR_OK) {
          // this.categoryList = res.data.records;
          this.categoryOptions = res.data.records.map(item => {
            return {
              value: item.id,
              label: item.name,
              children: item.storeCategoryVos.map(s => {
                return {
                  value: s.id,
                  label: s.name
                };
              })
            };
          });
        } else {
          Error(this, res);
        }
      });
    }
  }
};
</script>

<style scoped>
.store-add .content {
  padding: 20px;
}

.store-add .content .btn-submit {
  margin: 0 auto;
  display: block;
}

.amap-box {
  height: 500px;
  width: 500px;
}
</style>



// WEBPACK FOOTER //
// src/components/store/pageAdd.vue